import { Helmet } from "react-helmet-async";
import { useLanguage, SUPPORTED_LANGS, DEFAULT_LANG } from "../i18n";

const SITE_URL = "https://www.oxelokrog.se";

const localeMap = {
  sv: "sv_SE",
  en: "en_US",
  de: "de_DE",
};

function getBasePath(pathname) {
  return pathname.replace(/^\/(en|de)/, "") || "/";
}

const SEO = ({ pageKey }) => {
  const { lang, t } = useLanguage();

  const title = t(`meta.${pageKey}.title`);
  const description = t(`meta.${pageKey}.description`);

  const basePath = typeof window !== "undefined" ? getBasePath(window.location.pathname) : "/";

  const canonicalPath = lang === DEFAULT_LANG ? basePath : `/${lang}${basePath}`;
  const canonical = `${SITE_URL}${canonicalPath}`;

  return (
    <Helmet>
      <html lang={lang} />
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={canonical} />

      {SUPPORTED_LANGS.map((l) => {
        const href = l === DEFAULT_LANG
          ? `${SITE_URL}${basePath}`
          : `${SITE_URL}/${l}${basePath}`;
        return <link key={l} rel="alternate" hrefLang={l} href={href} />;
      })}
      <link rel="alternate" hrefLang="x-default" href={`${SITE_URL}${basePath}`} />

      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:locale" content={localeMap[lang] || "sv_SE"} />
      <meta property="og:url" content={canonical} />
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="Oxelö Krog" />
    </Helmet>
  );
};

export default SEO;
